import {getUrls} from '@config/endpoints';
import {httpAuth} from '@http/httpAuth';
import {
    ILiveEventResponse,
    IQuestion,
    IQuestionFilterParams,
    IQuestionsResponse,
} from '@services/live-event/live-event.model';
import {ILiveEvent} from '@services/live-events/live-events.model';

class LiveEventService {
    static getLiveEvent = async (slug: string) => {
        const {data} = await httpAuth.get<ILiveEventResponse>(
            getUrls().LIVE_EVENT(slug),
            {
                redirectNotFoundStatus: [404],
            },
        );

        return data.webinar;
    };

    static getQuestionsFiltered = async (params: IQuestionFilterParams) => {
        const {data} = await httpAuth.get<IQuestionsResponse>(
            getUrls().LIVE_EVENT_QUESTIONS,
            {
                params,
            },
        );

        return data;
    };

    static createQuestion = async (
        liveEventId: ILiveEvent['id'],
        question: string,
    ) => {
        await httpAuth.post(getUrls().LIVE_EVENT_QUESTION_CREATE(liveEventId), {
            question: question,
        });
    };

    static upvoteQuestion = async (questionId: IQuestion['id']) => {
        const {status} = await httpAuth.post(
            getUrls().LIVE_EVENT_QUESTION_UPVOTE(questionId),
        );

        return status;
    };

    static removeUpvoteQuestion = async (questionId: IQuestion['id']) => {
        const {status} = await httpAuth.post(
            getUrls().LIVE_EVENT_QUESTION_REMOVE_UPVOTE(questionId),
        );

        return status;
    };
}

export default LiveEventService;
